import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router";
import {
  calcullateItems,
  customToast,
  createCompanyDynamicUrl,
  getFormattedCondition,
  getProductDetailCardTags,
  getQuantityValue,
  getReceiptPrintDate,
  getShortestSku,
  getTotalCogsOrSubTotalOfProcessedTransaction,
  getVoidButtonTooltip,
  isReturnTransaction,
  isSaleTransaction,
  isShopifyTransaction,
  isTradeTransaction,
  isVoidDisabled,
  isVoidTransaction,
  parseJsonObject,
  parseToDecimalNumber,
  formatCurrency,
} from "../../utility";
import SelectedCustomerCard from "../customers/SelectedCustomerCard";
import {
  buttonNameConstants,
  buttonTypeConstants,
  categoryDropdownConstants,
  EMPTY_STRING,
  globalConstants,
  inventoryConstants,
  toastMessages,
  toastType,
  transactionConstants,
  routesPathConstants,
} from "../../../constants";
import CustomerDropdown from "../selectDropdown/CustomerDropdown";
import Button from "../Buttons/Button";
import {
  ACTIVITY_TYPES_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../../../system/globalEnums";
import SelectDropDown from "../selectDropdown/SelectDropdown";
import ButtonWithToolTip from "../Buttons/ButtonWithToolTip";
import { viewCartPrintDropdownStyle } from "../../../assets/scss/style/viewCartPrintDropdownStyle";
import PrintLabelModal from "../../../views/Inventory/Items/printingLabelModal/PrintLabelModal";
import AddNewCustomerModal from "../../../views/SellAndTrade/NewTransaction/AddNewCustomer/AddNewCustomerModal";
import SendReceiptModal from "../../../views/SellAndTrade/History/ImportTransactionHistory/SendReceiptModal";
import { connect } from "react-redux";
import { transactionActions } from "../../../redux/actions";

const TransactionHistoryOrderDetailsModal = ({
  show,
  handleHideModal,
  hasAccessToVoidTransaction,
  viewCartDetail = [],
  allCustomers,
  handleUpdateCustomer,
  handlePrintReceipt,
  sendEmailOrSMS,
  handleInitiateVoid,
  // Redux actions
  toggleAddCustomerModal,
  // Redux states
  isAddCustomerModal,
  currentStore,
}) => {
  const navigate = useNavigate();
  const transaction = viewCartDetail?.[0];
  const [selectedCustomerFlag, setSelectedCustomerFlag] = useState(false);
  const [isReceiptModal, setIsReceiptModal] = useState(false);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [customerToEdit, setCustomerToEdit] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);

  const handleAddCustomerClick = () => {
    toggleAddCustomerModal(true);
  };

  const handleAddNewCustomerClick = () => {
    setCustomerToEdit({});
    toggleAddCustomerModal(true);
  };

  const handleCustomerEditClick = () => {
    const customer = allCustomers?.find(
      (customerItem) => customerItem.id === transaction?.customer?.id
    );
    if (customer?.id) {
      setCustomerToEdit(customer);
      toggleAddCustomerModal(true);
    }
  };

  const handlePrintProductLabel = () => {
    const rows = (transaction?.inventory || []).map((item) => {
      const newObject = {
        sku: getShortestSku(item.sku),
        product_name: item.product_name,
        productType: item.productType,
        price: {
          quantity: item?.price?.quantity,
          type: item?.price?.type,
          unit_sell_price: isTradeTransaction(transaction)
            ? item?.price?.unit_sell_price
            : item?.price?.unit_purchase_price,
        },
        category_name: item?.category_name || item?.category,
        tags: item?.tags,
      };
      return newObject;
    });
    setSelectedRows(rows);
    setPrintLabelModal(true);
  };

  const handleIssueRefund = () => {
    navigate(
      createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_RETURN),
      {
        state: { id: transaction?.id },
      }
    );
  };

  const toggleIsReceiptModal = () => {
    setIsReceiptModal((prev) => !prev);
  };

  useEffect(() => {
    if (allCustomers && allCustomers.length > 0 && selectedCustomerFlag) {
      handleUpdateCustomer({
        ...allCustomers[0],
        name: allCustomers[0].firstName + " " + allCustomers[0].lastName,
      });
    }
    setSelectedCustomerFlag(false);
  }, [allCustomers, selectedCustomerFlag]);

  return (
    <Modal
      show={show}
      onHide={handleHideModal}
      size={`${hasAccessToVoidTransaction ? "lg" : "md"}`}
      animation={true}
      centered
      backdrop="static"
      className="add-inventory-modal"
    >
      <Form className="px-0">
        <Modal.Header closeButton>
          <Modal.Title className="d-flex flex-column">
            <span className="modal-sale-transaction-id d-flex align-items-center">
              {isTradeTransaction(viewCartDetail?.[0])
                ? "Trade "
                : isReturnTransaction(viewCartDetail?.[0])
                ? "Return "
                : "Sale "}
              ({viewCartDetail?.[0]?.id})
            </span>
            {isVoidTransaction(transaction) && (
              <span className="text-danger fw-bold fs-6 mt-1">
                (VOIDED -{" "}
                {new Date(
                  transaction?.voidedAt || transaction?.createdOn
                ).toLocaleString()}
                )
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Row className="my-2">
            {isVoidTransaction(transaction) && transaction?.voidedBy?.name && (
              <div className="d-flex gap-1">
                <span className="fw-bold fs-6 mt-1">Voided by:</span>
                <span className="fs-6 mt-1">{transaction.voidedBy.name}</span>
              </div>
            )}

            {isVoidTransaction(transaction) && transaction?.voidReason && (
              <div className="d-flex gap-1">
                <span className="fw-bold fs-6 mt-1">Voided reason:</span>
                <span className="fs-6 mt-1">{transaction.voidReason}</span>
              </div>
            )}
            {transaction?.isVoidTransaction && (
              <div className="d-flex gap-1">
                <span className="fw-bold fs-6 mt-1">
                  Original Transaction ID:
                </span>
                <span className="fs-6 mt-1">
                  {transaction.originalTransactionId}
                </span>
              </div>
            )}
          </Row>
          <Row className="m-0 p-0">
            <Col md={12} className="p-0 mb-2">
              <span className="trans-items-modal view-cart-date">
                {getReceiptPrintDate(viewCartDetail?.[0]?.createdOn)}
              </span>
            </Col>
            <Col md={12} className="p-0 mb-4 mt-2">
              {Array.isArray(viewCartDetail) &&
              viewCartDetail?.[0]?.customer?.id ? (
                <SelectedCustomerCard
                  customer={viewCartDetail?.[0]?.customer}
                  isDeleteEditOptions={true}
                  isStoreCredit={false}
                  handleCustomerDeleteClick={() => {
                    if (
                      viewCartDetail?.[0]?.paymentHistory?.totalPaidAmount
                        ?.storeCredit > 0
                    ) {
                      customToast(
                        toastMessages.UPDATE_CUSTOMER_ERROR,
                        toastType.ERROR
                      );
                    } else {
                      handleUpdateCustomer(false);
                    }
                  }}
                  handleCustomerEditClick={handleCustomerEditClick}
                  className={{
                    parnetDiv: "selected-customer-wrapper gap-3",
                    nameDiv: "selected-customer-wrapper",
                    nameSpan: "trans-product-name-modal-total",
                    editDeleteDiv: "ms-auto",
                    deleteButton: "p-0 opacity-50",
                    editButton: "p-0 opacity-50",
                  }}
                  isShopifyTransaction={isShopifyTransaction(
                    viewCartDetail?.[0]?.id
                  )}
                />
              ) : isAddCustomerModal ? (
                <Button
                  className="p-0"
                  type="button"
                  label={buttonNameConstants.ADD_CUSTOMER}
                  buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                  handleClick={handleAddCustomerClick}
                />
              ) : (
                <CustomerDropdown
                  value={""}
                  menuPortalTarget=""
                  dropdownIndicator={false}
                  noOptionsMessage="No Customer Found"
                  placeholder="Customer Name, Phone, Email"
                  handleAddCustomerClick={handleAddNewCustomerClick}
                  SelectIconImage={categoryDropdownConstants.SEARCH_ICON}
                  handleChange={(selectedOption) => {
                    if (selectedOption?.value) {
                      handleUpdateCustomer(
                        parseJsonObject(selectedOption?.value)
                      );
                    }
                  }}
                  selectedCustomerFlag={selectedCustomerFlag}
                />
              )}
            </Col>
          </Row>
          <Row className="m-0 p-0 ">
            <div className="container-scrollbar p-0  trans-modal-card-wrapper ">
              <Row className="m-0">
                <Col
                  sm={6}
                  className="px-0 d-flex align-items-center mb-3 history-cart-table-header"
                >
                  Product Name
                </Col>
                <Col
                  sm={3}
                  className="px-0 d-flex align-items-center justify-content-end mb-3 history-cart-table-header"
                >
                  {isTradeTransaction(viewCartDetail?.[0])
                    ? "Stock Price"
                    : "COGS"}
                </Col>
                <Col
                  sm={3}
                  className="px-0 d-flex align-items-center justify-content-end mb-3 pe-1 history-cart-table-header"
                >
                  {isTradeTransaction(viewCartDetail?.[0])
                    ? "COGS"
                    : "Stock Price"}
                </Col>
                {Array.isArray(viewCartDetail) &&
                  viewCartDetail?.[0]?.inventory?.map((product) => {
                    return (
                      <>
                        <Col sm={6} className="px-0 d-flex align-items-center">
                          <div className="d-flex align-items-center gap-1">
                            <span className="trans-items-modal">
                              {getQuantityValue(product, true, true)}
                            </span>
                            <span className="trans-product-name-modal">
                              {product.product_name}
                            </span>
                            <span className="trans-items-modal">
                              {product?.sku !==
                                transactionConstants.QUICK_TRADE &&
                                `#${getShortestSku(product?.sku)}`}
                            </span>
                          </div>
                        </Col>
                        <Col
                          sm={3}
                          className="px-0 d-flex align-items-center justify-content-end"
                        >
                          <div>
                            <span className="trans-product-name-modal">
                              {formatCurrency(
                                isTradeTransaction(viewCartDetail?.[0])
                                  ? product?.price?.unit_sell_price
                                  : product?.cogs
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col
                          sm={3}
                          className="px-0 d-flex align-items-center justify-content-end"
                        >
                          <div>
                            <span className="trans-product-name-modal">
                              {formatCurrency(
                                isTradeTransaction(viewCartDetail?.[0])
                                  ? product?.price?.unit_purchase_price
                                  : product?.price?.unit_purchase_price
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col
                          md={12}
                          className={`m-0 p-0
                             d-flex justify-content-between ${
                               product?.discountPercentage > 0
                                 ? EMPTY_STRING
                                 : "mb-3"
                             }`}
                        >
                          <div className="d-flex align-items-center gap-1">
                            <span className="trans-items-modal ms-3">
                              {isTradeTransaction(viewCartDetail?.[0])
                                ? product?.["category_name"]
                                : product?.category}
                            </span>
                            <span className="trans-items-modal">
                              ({getFormattedCondition(product)})
                            </span>
                            {
                              // Show serial number for systems/consoles if found
                              product?.subcategory ===
                                TRADING_CARD_CATEGORIES_ENUMS.SYSTEM &&
                                product?.serialNumber && (
                                  <span className="trans-items-modal">
                                    S/N : {product?.serialNumber}
                                  </span>
                                )
                            }
                            <span className="trans-items-modal">
                              {getProductDetailCardTags(
                                product.tags?.filter(
                                  (tag) =>
                                    tag !== inventoryConstants.CUSTOM_ITEM_TAG
                                ),
                                product.sku
                              )}
                            </span>
                          </div>
                        </Col>
                        {Number(product?.discountPercentage) > 0 && (
                          <>
                            <Col
                              sm={6}
                              className="px-0 d-flex align-items-center mb-3"
                            >
                              <div className="d-flex align-items-center gap-1">
                                <span className="trans-product-name-modal ps-5">
                                  {`Discount(${
                                    product.isToggleDiscount
                                      ? formatCurrency(
                                          product.discountPercentage
                                        )
                                      : `${product.discountPercentage}%`
                                  })`}
                                </span>
                              </div>
                            </Col>
                            <Col
                              sm={6}
                              className="px-0 d-flex align-items-center justify-content-end mb-3"
                            >
                              <div>
                                <span className="trans-product-name-modal">
                                  -{" "}
                                  {formatCurrency(
                                    product.isToggleDiscount
                                      ? product.discountPercentage
                                      : (Number(product.actualPrice) *
                                          Number(product.discountPercentage)) /
                                          100
                                  )}
                                </span>
                              </div>
                            </Col>
                          </>
                        )}
                      </>
                    );
                  })}
              </Row>
            </div>
            <Col
              md={12}
              className="m-0 mt-2 mb-2 p-0 d-flex justify-content-between tran-modal-detail-margin"
            >
              <div className="trans-product-name-modal-text m-0">Subtotal</div>

              <div className="">
                {formatCurrency(
                  getTotalCogsOrSubTotalOfProcessedTransaction(
                    transaction,
                    false,
                    true
                  )
                )}
              </div>
            </Col>
            <>
              {
                // discount is visible in case of sale transaction
                isSaleTransaction(viewCartDetail?.[0]) && (
                  <Col
                    md={12}
                    className="m-0  mb-2 p-0 d-flex justify-content-between tran-modal-detail-margin"
                  >
                    <div className="trans-product-name-modal-text m-0">
                      Discount
                    </div>
                    <div className="">
                      {formatCurrency(viewCartDetail?.[0]?.discount)}
                    </div>
                  </Col>
                )
              }
              {
                // tax is visible in case of sale and return transaction
                (isSaleTransaction(viewCartDetail?.[0]) ||
                  isReturnTransaction(viewCartDetail?.[0])) && (
                  <Col
                    md={12}
                    className="m-0  mb-2 p-0 d-flex justify-content-between tran-modal-detail-margin"
                  >
                    <div className="trans-product-name-modal-text m-0">
                      {`Tax(
                  ${parseToDecimalNumber(
                    viewCartDetail?.[0]?.taxPercentage ?? 0
                  )}
                  %)`}
                    </div>
                    <div className="">
                      {formatCurrency(viewCartDetail?.[0]?.Tax ?? 0)}
                    </div>
                  </Col>
                )
              }
            </>

            <Col
              md={12}
              className="m-0  mb-2 p-0 pt-2 d-flex justify-content-between border-top tran-modal-detail-margin"
            >
              <div className="trans-product-name-modal-total m-0">
                TOTAL ({calcullateItems(viewCartDetail?.[0]?.inventory)} items)
              </div>

              <div className="trans-product-name-modal-total">
                {formatCurrency(
                  isTradeTransaction(viewCartDetail?.[0])
                    ? viewCartDetail?.[0]?.initialTotalCogs
                    : viewCartDetail?.[0]?.totalAmountToPay
                )}
              </div>
            </Col>
            {
              // PAYMENT HISTORY: history is generating in case of transaction (sale) and trade and in case of return use the current paid values as there is no split payment feature in return transaction
              isReturnTransaction(viewCartDetail?.[0]) ? (
                <Col
                  md={12}
                  className="m-0 p-0 mb-1 d-flex justify-content-between"
                >
                  <div className="d-flex align-items-center gap-1">
                    <span className="trans-product-name-modal-text">
                      {viewCartDetail?.[0].PaymentType ===
                      transactionConstants.CREDIT_CARD
                        ? buttonNameConstants.CREDIT_CARD
                        : viewCartDetail?.[0].PaymentType ===
                          transactionConstants.STORE_CREDIT
                        ? buttonNameConstants.STORE_CREDIT
                        : viewCartDetail?.[0].PaymentType ===
                          transactionConstants.GIFT_CARD
                        ? viewCartDetail?.[0]?.giftCard?.giftCardName
                        : viewCartDetail?.[0].PaymentType ===
                          transactionConstants.OTHER
                        ? buttonNameConstants.OTHER
                        : buttonNameConstants.CASH}
                    </span>
                  </div>
                  <div>
                    <span className="trans-product-name-modal-text">
                      {formatCurrency(viewCartDetail?.[0]?.totalAmountToPay)}
                    </span>
                  </div>
                </Col>
              ) : (
                viewCartDetail?.[0]?.paymentHistory?.history?.map((history) => {
                  return history.isUndoTransaction ? (
                    <Col
                      md={12}
                      className="m-0 p-0 mb-1 d-flex justify-content-between"
                    >
                      <div className="d-flex align-items-center gap-1">
                        <span className="trans-product-name-modal-text">
                          {history.paymentType ===
                          transactionConstants.CREDIT_CARD
                            ? buttonNameConstants.CREDIT_CARD
                            : history.paymentType ===
                              transactionConstants.STORE_CREDIT
                            ? buttonNameConstants.STORE_CREDIT
                            : history.paymentType ===
                              transactionConstants.GIFT_CARD
                            ? history?.giftCardName
                            : history.paymentType === transactionConstants.OTHER
                            ? buttonNameConstants.OTHER
                            : buttonNameConstants.CASH}
                        </span>
                      </div>
                      <div>
                        <span className="trans-product-name-modal-text">
                          {formatCurrency(history?.currentAmountToPay)}
                        </span>
                      </div>
                    </Col>
                  ) : (
                    ""
                  );
                })
              )
            }
          </Row>
          {viewCartDetail?.[0]?.note && (
            <Col md={12} className="m-0 mt-3   p-0">
              <div className="note-text-div container-scrollbar">
                <p className="trans-items-modal mb-2">Note</p>
                <span className="note-text">{viewCartDetail?.[0]?.note}</span>
              </div>
            </Col>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center gap-2 w-100">
            <Button
              type="button"
              label={buttonNameConstants.CLOSE}
              handleClick={() => handleHideModal()}
              buttonType={buttonTypeConstants.GHOST_BUTTON}
              className="w-100"
            />
            <SelectDropDown
              outerWrapperClassname="w-100"
              menuPortalTarget=""
              isSingleValue="Receipt"
              placeHolder="Receipt"
              handleChange={(option) => {
                if (
                  option?.value === transactionConstants.RECEIPT_OPTION.PRINT
                ) {
                  handlePrintReceipt(transaction);
                } else if (
                  option?.value ===
                  transactionConstants.RECEIPT_OPTION.GIFT_RECEIPT
                ) {
                  handlePrintReceipt(transaction, true);
                } else if (
                  option?.value === transactionConstants.RECEIPT_OPTION.SEND
                ) {
                  toggleIsReceiptModal();
                }
              }}
              styles={viewCartPrintDropdownStyle}
              menuPlacement="bottom"
              options={transactionConstants.RECEIPT_OPTIONS}
            />

            {viewCartDetail?.[0]?.id.substring(0, 3) ===
            globalConstants.TYPE_ID_TRA ? (
              <ButtonWithToolTip
                type="button"
                toolTipRootClassName="w-100"
                className="w-100"
                toolTipBody={getVoidButtonTooltip(viewCartDetail?.[0], true)}
                placement="top"
                isDisabled={
                  isShopifyTransaction(viewCartDetail?.[0]?.id) ||
                  isVoidTransaction(viewCartDetail?.[0])
                }
                style={{
                  pointerEvents: isVoidDisabled(viewCartDetail?.[0])
                    ? "none"
                    : "auto",
                }}
                label={buttonNameConstants.ISSUE_REFUND}
                handleClick={handleIssueRefund}
              />
            ) : viewCartDetail?.[0]?.id.substring(0, 3) ===
              globalConstants.TYPE_ID_TRD ? (
              <Button
                type="button"
                className="w-100"
                label={buttonNameConstants.PRINT_PRODUCT_LABEL}
                handleClick={handlePrintProductLabel}
              ></Button>
            ) : (
              ""
            )}
            {hasAccessToVoidTransaction &&
              viewCartDetail?.[0]?.type !== ACTIVITY_TYPES_ENUMS.RETURN && (
                <ButtonWithToolTip
                  type="button"
                  toolTipRootClassName="w-100"
                  className="w-100"
                  toolTipBody={getVoidButtonTooltip(viewCartDetail?.[0])}
                  placement="top"
                  isDisabled={isVoidDisabled(viewCartDetail?.[0])}
                  style={{
                    pointerEvents: isVoidDisabled(viewCartDetail?.[0])
                      ? "none"
                      : "auto",
                  }}
                  label={buttonNameConstants.VOID_TRANSACTION}
                  handleClick={() => handleInitiateVoid(viewCartDetail?.[0])}
                />
              )}
          </div>
        </Modal.Footer>
      </Form>
      <PrintLabelModal
        printLabelModal={printLabelModal}
        togglePrintLabelModal={() => {
          setPrintLabelModal(false);
          setSelectedRows([]);
        }}
        selectedRows={selectedRows}
      />
      <SendReceiptModal
        sendEmailOrSMS={sendEmailOrSMS}
        transactionData={transaction}
        isReceiptModal={isReceiptModal}
        toggleIsReceiptModal={toggleIsReceiptModal}
        currentStore={currentStore}
      />
      {isAddCustomerModal && (
        <AddNewCustomerModal
          selectedCustomer={() => setSelectedCustomerFlag(true)}
          addCustomerModal={isAddCustomerModal}
          customerToEdit={customerToEdit}
        />
      )}
    </Modal>
  );
};
const mapStateToProps = (state) => ({
  isAddCustomerModal: state.transaction.isAddCustomerModal,
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  toggleAddCustomerModal: (value) =>
    dispatch(transactionActions.toggleAddCustomerModal(value)),
});

//-------Export TransactionHistoryOrderDetailsModal Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionHistoryOrderDetailsModal);
